import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useNavigate, Link } from "react-router-dom";
import { GENERATE_LOGIN_OTP , VERIFY_CONTACT_NUMBER , RESET_USER_DETAILS} from "../../redux/constant";
import { toast } from "../../Utills/toast";
import { ButtonLoader } from '../../component/common/Loader';

const ILogin = ({ setOtpStage = () => { }, setPhoneNo =() => {}, setRestaurantId =()=>{} }) => {
    const [phoneNumber, setPhoneNumber] = useState('');
    const [restaurantOrBranchId, setVerifyUser] = useState('');
    const users = useSelector((state) => state.user.userDetail);
    const loading = useSelector((state) => state.user.loading);
    const dispatch = useDispatch();
    // todo: get url extention for restaurant Data userDetail

     useEffect(() => {

        if (users !== null && users?.length === 0 && phoneNumber.length === 10) {
        toast.error("This phone number is not registered with any restaurant.");
        // Optional: clear the phone number or reset state
        return;
    }

    // Check if we have exactly one user and a valid phone number
    if (phoneNumber.length === 10 && users?.length === 1) {
        const singleUser = users[0];
        const rId = singleUser.restaurantOrBranchId;         

        // 1. Dispatch the verification with the only available restaurant ID
        dispatch({ 
            type: VERIFY_CONTACT_NUMBER, 
            payload: { phoneNumber, restaurantOrBranchId: rId } 
        });

        // 2. Update parent state
        setOtpStage(true);
        setPhoneNo(phoneNumber);
        setRestaurantId({ userId: singleUser.userId, restaurantOrBranchId: rId });
    }

    if (users?.length > 1){
          if (!restaurantOrBranchId) {
            toast.warn("Please select a restaurant from the list.");
            return;
        }
    }
}, [users, phoneNumber, dispatch]); // Dependencies: trigger when users list or phone changes

   


    const handlePhoneNumberChange = (event) => {
        const inputValue = event.target.value;
        // Allow only numbers and limit to 10 digits
        const sanitizedValue = inputValue.replace(/[^0-9]/g, '').slice(0, 10);
        setPhoneNumber(sanitizedValue);
        // ✅ Reset users to null when they start typing a new number
        if (users !== null) {
         dispatch({ type: "RESET_USER_DETAILS" }); // This action should set userDetail to null
        }
    };

    // const handleGenerateOtp = () => {
    //     if (phoneNumber.length === 10 && users.length  === undefined ) {
    //         dispatch({ type: GENERATE_LOGIN_OTP, payload: phoneNumber })
            
    //     } else if (phoneNumber.length === 10 && users.length  >  1){
    //         dispatch({ type: VERIFY_CONTACT_NUMBER, payload: {phoneNumber,restaurantOrBranchId }  })
    //          setOtpStage(true);
    //          setPhoneNo(phoneNumber);
    //          setRestaurantId(users[0].userId);
    //     } 
    //     else {
    //         toast.info('Please enter a valid 10-digit phone number.');
    //     }
    // };

       const handleGenerateOtp = () => {
    if (phoneNumber.length !== 10) {
        toast.info('Please enter a valid 10-digit phone number.');
        return;
    }
    // State 1: First time clicking (users is empty/undefined)
    if ( users === undefined || users === null || users.length === 0) {
        dispatch({ type: GENERATE_LOGIN_OTP, payload: phoneNumber });
    } 
    // State 2: Multiple restaurants found, user has selected one from dropdown
    else if (users?.length > 1) {
             if(restaurantOrBranchId === '' || restaurantOrBranchId === undefined || restaurantOrBranchId === null){
            toast.warn("Please select a restaurant.");
            return false;
        }

        dispatch({ 
            type: VERIFY_CONTACT_NUMBER, 
            payload: { phoneNumber, restaurantOrBranchId } 
        });
        setOtpStage(true);
        setPhoneNo(phoneNumber);
        
        // Find the specific user object that matches the selection for the ID
        const selectedUser = users?.find(u => u.restaurantOrBranchId === restaurantOrBranchId);
        setRestaurantId(selectedUser ? {
            userId: selectedUser.userId,
            restaurantOrBranchId: selectedUser.restaurantOrBranchId
        } : null);
    }
};
// Transform the users array for the Select component
// ✅ Safe mapping: returns an empty array if users is null/undefined
const restaurantOptions = users?.length > 0 
    ? users.map(r => ({
        value: r.restaurantOrBranchId,
        label: `${r.restaurantOrBranchDetail?.restaurantOrBranchName} - ${r.restaurantOrBranchDetail?.address}`
      })) 
    : [];
    return (
        <>
            <input
                required
                type="tel"
                className="loginInput"
                id="phoneNumber"
                value={phoneNumber}
                disabled = {users?.length > 0}
                onChange={handlePhoneNumberChange}
                placeholder="Enter 10-digit phone number"
            />
       

    {users?.length > 1 && (
        <div  style={{  width: "100%", margin: "12px auto", marginBottom:20, maxWidth: "300px"}} >
  {/* <label htmlFor="selectedUserId">Restaurant:</label> */}
  <Select
    id="selectedUserId"
    // Find the current selected object based on the ID stored in your state
    value={restaurantOptions.find(option => option.value === restaurantOrBranchId) || null}
    
    // Pass the mapped options
    options={restaurantOptions}
    
    // React-select returns the whole object on change, so we take .value
    onChange={(selectedOption) => setVerifyUser(selectedOption ? selectedOption.value : '')}
    
    placeholder="Select a restaurant"
    isSearchable={true}
    isClearable={true}
    classNamePrefix="react-select"
  />
        </div>         
    )}

   
               
            <button onClick={handleGenerateOtp} className="full-btn">
               {loading ? <ButtonLoader label="Generating OTP..." /> : "Generate OTP"}
            </button>
        </>
    )
}

export default ILogin;


